import { ImpressionModalityScope } from '../generated/graphql';
import { useCurrentUser } from 'hooks/useCurrentUser';
import { useFeatureFlagEnabled, FF } from 'modules/feature-flags';
import { useCurrentCaseContext } from 'common/CurrentCase/CurrentCaseProvider';
import type { DefaultContext } from '@apollo/client';

type Options = {
  context?: DefaultContext;
};

export const useIsAutoImpressionAllowedForModality = ({ context }: Options = {}): boolean => {
  const { data } = useCurrentUser({ context });
  const impressionGeneratorSettings = data?.me?.reporterSettings?.impressionGenerator;
  const { currentCase } = useCurrentCaseContext();
  const [isImpressionModalityScopeEnabled] = useFeatureFlagEnabled(
    FF.REPORTER_AUTO_IMPRESSIONS_MODALITY_SCOPE
  );

  const modalityScope = impressionGeneratorSettings?.modalityScope;
  const modality = currentCase?.modality;

  if (isImpressionModalityScopeEnabled && modalityScope === ImpressionModalityScope.All) {
    return true;
  }

  return modality != null && (impressionGeneratorSettings?.modalities?.includes(modality) ?? false);
};
